/** Form state key for a FieldDef — uses fieldId if set, otherwise tag. */
export var stateKey = function (fd) { return fd.fieldId || fd.tag; };
/**
 * Whether a FieldDef carries an identity beyond its MARC tag — i.e. is a named
 * VARIANT (`024-isni`, `370-place`) rather than the plain field of its tag.
 *
 * CZNA-902 gave every packaged field a `fieldId`, and a field that was the plain
 * one of its tag got the bare tag (`"100"`). That id names nothing the tag did
 * not, and its `stateKey` is the same string as before; so the places that ask
 * "is this lone field a variant?" (`resolveTargetKey`, `recordFormAffordance`)
 * ask it here, and those 152 fields keep the behaviour they had without an id.
 */
export var hasVariantIdentity = function (fd) {
    return !!fd.fieldId && fd.fieldId !== fd.tag;
};
